export default "__VITE_ASSET__iQZxlhVM__"